<template>
  <div class="expire-statistical" v-if="expireSabbatical.length> 0">
    <SabbaticalItems v-for="(item, index) in expireSabbatical" :key="index" :sabbaticalInfo="item"/>
  </div>
  <div v-else class="expire-statistical">{{$t("sabbatical.sabbatical_expiring_leave")}}</div>
</template>
<script>
import { mapGetters } from "vuex";
import SabbaticalItems from "./SabbaticalItems.vue";
export default {
  name: "ExpireSabbatical",
  data() {
    return {};
  },
  components: {
    SabbaticalItems,
  },
  computed: {
    ...mapGetters({
      expireSabbatical: "sabbatical-leave-request/expireSabbatical",
    }),
  },
  methods: {
    async initial() {
      await this.getExpireSabbatical();
    },
    async getExpireSabbatical() {
      this.$root.$loading.start();
      await this.$store.dispatch(
        "sabbatical-leave-request/getExpireSabbatical",
      );
      this.$root.$loading.finish();
    }
  },
  created() {
    this.initial();
  },
};
</script>
<style lang="scss" scoped>
.expire-statistical {
  padding: 15px 0 5px;
}
</style>
